import { useQuery } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import {
  SegmentDefinition,
  SegmentPreviewResponse
} from "../../marketing.types";
import { requestGetSegmentPreview } from "./getSegmentPreview.request";

const useSegmentPreview = (
  definition: SegmentDefinition,
  options?: QueryOptions<SegmentPreviewResponse, ApiServiceError<ApiError>>
) => {
  const { data, ...rest } = useQuery({
    queryKey: ["marketing", "segments", "preview", definition],
    queryFn: async () => await requestGetSegmentPreview(definition),
    onError: toastServerError,
    keepPreviousData: true,
    ...options
  });

  return { count: data?.count, ...rest };
};

export default useSegmentPreview;
